import { combineReducers } from 'redux';

import oauth from './oauth';
import error from './error';
import users from './users';
import stratas from './stratas';
import orders from './orders';
import session from './session';
import loading from './loading';
import councils from './councils';
import messages from './messages';
import providers from './providers';
import pendingOrder from './pending-order';

export default (state, action) =>
  combineReducers({
    error,
    users,
    oauth,
    orders,
    stratas,
    session,
    loading,
    messages,
    councils,
    providers,
    pendingOrder: pendingOrder
  })(state, action);
